import type { ReactNode } from "react";

export interface CardOptionRowProps {
    title: string;
    children: ReactNode;
}

export const CardOptionRow = (props: CardOptionRowProps) => {
    return (
        <div className="bg-white border border-p6-grey-light rounded-medium px-m py-s flex flex-wrap items-center justify-between gap-s">
            <span className="font-semibold text-l text-p6-grey-dark">{props.title}</span>
            <div className="flex items-center gap-s flex-wrap">{props.children}</div>
        </div>
    );
};
